import { gql } from '@apollo/client';

export const GET_ME = gql`
query Membership {
  me {
    organisation {
      currentBlockTag {
        id
        code
        name
      }
      nextBlockTag {
        id
        code
        name
      }
      membership {
        isAdmin
        isTeacherPersona
        isCenterManager
        isCourseAdmin
      }
    }
  }
}`;
